export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8243.9ec64d34.jpg";